import { Component, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwSecurityUserRegistration, DwUserRegistrationExtensionBase, DwUserTypeEntity, getParameterByName } from '@devwareapps/devware-cap';
import { AviatorOnlineHomePageRepository } from '../../services/home-page-repository.service';
import { DwUserTypeExtensionEntity } from '../../../../meta-data/extensions/dw-user-type-entity.model';
import { AviatorOnlineUserTypeIds, convertUserType } from '../../../shared/models/aviator-user-type.enum';
import { Router } from '@angular/router';
import { FlightSchoolSignup } from '../../models/flight-school-signup.model';
import { AppMetaData, FlightSchoolEntity, JoinRequestTypeAllItems } from '../../../../meta-data/app-meta-data.service';
import { IntegrationUtilService } from '../../../integration/services/integration-util.service';
import { IntegrationTypes } from '../../../integration/models/integration-request-token.model';
import { SchoolRepositoryService } from '../../../schools/services/school-repository.service';
import { take } from 'rxjs/operators';

@DwComponent({
  key: 'aviator-online-user-registration-extension',
  name: 'Aviator Online User Registration Component',
  isGlobal: false,
  componentType: DwComponentType.pageComponent
})
@Component({
  selector: 'app-user-registration',
  templateUrl: './user-registration.component.html',
  styleUrls: ['./user-registration.component.scss']
})
export class UserRegistrationComponent extends DwUserRegistrationExtensionBase {

  userTypes: DwUserTypeEntity[];
  userType: AviatorOnlineUserTypeIds;

  schoolUserType: AviatorOnlineUserTypeIds = AviatorOnlineUserTypeIds.flightSchool;
  flightSchoolSignupInfo: FlightSchoolEntity;

  showSchoolDetails: boolean = false;
  isFlightSchoolRegistration: boolean = false;

  constructor(private router: Router,
    private homePageRepository: AviatorOnlineHomePageRepository,
    private integrationUtilService: IntegrationUtilService,
    private schoolRepositoryService: SchoolRepositoryService) {
    super();
  }

  setupComponent() {
    this.flightSchoolSignupInfo = {
      _itemName: AppMetaData.FlightSchool.ItemDetail.itemName,
    };

    const userTypeMeaning = getParameterByName(this.router, 'type');

    if (!isNaN(parseInt(userTypeMeaning))) {
      this.userType = parseInt(userTypeMeaning);
    } else {
      this.userType = convertUserType(userTypeMeaning);
    }

    if (!this.userType) {
      this.userType = AviatorOnlineUserTypeIds.student;
    }

    const integrationTokenRequest = this.integrationUtilService.getIntegrationTokenDetails();

    if (integrationTokenRequest?.integrationType == IntegrationTypes.schoolAuth) {
      this.userType = AviatorOnlineUserTypeIds.flightSchool;

      this.userRegistrationDataChange.emit({
        Email: integrationTokenRequest?.userEmail,
      } as any);

      this.flightSchoolSignupInfo.FlightSchoolName = integrationTokenRequest?.organizationName;
    }

    const joinRequestPayload = this.integrationUtilService.getJoinRequestPayload();

    if (joinRequestPayload) {
       this.userRegistrationDataChange.emit({
        Email: joinRequestPayload?.email,
        lockEmail: true
      } as any);

      switch (joinRequestPayload.joinRequestTypeId) {
        case JoinRequestTypeAllItems.FlightInstructor:
          this.userType = AviatorOnlineUserTypeIds.flightInstructor;
          break;
        case JoinRequestTypeAllItems.StudentRequest:
          this.userType = AviatorOnlineUserTypeIds.student;
          break;
        case JoinRequestTypeAllItems.FlightSchoolAdmin:
          this.userType = AviatorOnlineUserTypeIds.flightSchool;
          break;
      }
    }


    this.updateFlightSchoolInfo();

    this.updateUserType();

    this.schoolRepositoryService.getSchoolFeatures()
      .pipe(take(1))
      .subscribe(features => {
        if (features?.RegistrationTypeKey !== 'FlightInstructor') {
          return;
        }

        this.userType = AviatorOnlineUserTypeIds.flightInstructor;
        this.updateUserType();
      });

    const discountCode = getParameterByName(this.router, 'discount');

    this.updateDiscountCode(discountCode);

    this.homePageRepository.getUserTypes().subscribe(userTypes => {
      this.userTypes = userTypes;

      if (!this.userTypes.find(ut => ut.UserTypeId === this.userType)) {
        this.userType = this.userTypes[0].UserTypeId;
      }
    });
  }

  customValalidation(userRegistration: DwSecurityUserRegistration, error: string[]) {
    if (!this.userType) {
      error.push('User type is required');
    }

    switch (this.userType) {
      case AviatorOnlineUserTypeIds.flightSchool:
        if (!this.flightSchoolSignupInfo?.FlightSchoolName) {
          error.push('School name is required');
        }
        if (!this.flightSchoolSignupInfo?.Location) {
          error.push('Location is required');
        }
    }
  }

  updateUserType() {
    this.data.additionalUserFields[0] = {
      FieldName: 'UserTypeId',
      FieldValue: this.userType.toString()
    };

    this.dataChange.emit(this.data);
  }

  updateFlightSchoolInfo() {
    this.data.additionalUserFields[1] = {
      FieldName: 'FlightSchoolName',
      FieldValue: this.flightSchoolSignupInfo.FlightSchoolName
    };
    this.data.additionalUserFields[2] = {
      FieldName: 'Location',
      FieldValue: this.flightSchoolSignupInfo.Location
    };
  }

  updateDiscountCode(discountCode: any) {
    this.data.additionalUserFields[3] = {
      FieldName: 'DiscountCode',
      FieldValue: discountCode
    };
  }

}
